<template>
    <div>
        <yes_no
            v-model="editSummMode"
            base_class="mt-3"
            title="Редагувати суми пропозицій"
        />
        <div ref="pos_items" id="positions" style="height:600px;display:block"></div>
        
        <div id="positions_control" style="width:100%;">
            <div class="row">
                <div class="col-6">
                    <div
                        class="btn btn-outline-primary btn_auto_render mb-2 mt-2 waves-effect waves-themed"
                        @click="auto_distribute"
                    >
                        Розподілити
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as W2 from 'w2ui'
import Yes_no from '../../../../base/yes_no.vue'

window.w2ui    = W2.w2ui
window.w2grid  = W2.w2grid
window.w2field = W2.w2field
window.query   = W2.query
window.w2utils = W2.w2utils
window.w2popup = W2.w2popup

export default {
    name: 'protocol_positions2',
    components: { Yes_no },
    props: {
        protocol: { type: Object, required: true }
    },
    data() {
        return { editSummMode: false }
    },
    
    created() {
        // из BVN-табов: удаление строки/таба
        EventBus.$on('winner_item_removed', ({ gridId }) => this.calcParams(gridId))
        
        // сброс из табов
        EventBus.$on('winners:reset', () => this.$nextTick(() => this.clearWinners()))
        
        // распределить из табов
        EventBus.$on('winners:auto_distribute',this.auto_distribute);
        
        // актуализация при показе вкладки
        EventBus.$on('tab-shown', (key) => {
            if (key === 'protocol_positions2' || key === 'protocol_positions') {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        if (w2ui.positions) w2ui.positions.refresh()
                    })
                })
            }
        })
    },
    
    mounted() {
        this.tryInit()
        
        // двойной клик по «добавить всё» на теге с .add_all (как было)
        jQuery(document).on('dblclick', '.add_all', (e) => {
            const $el = jQuery(e.currentTarget)
            const appId = $el.data('id') || String($el.data('app') || '').replace(/^app/, '')
            if (!appId) return
            this.addAll(appId.replace(/^app/, ''))
        })
    
    },
    beforeUnmount() {
        if (w2ui.positions) w2ui.positions.destroy()
    },
    
    watch: {
        position_data: {
            handler() {
                this.tryInit();
            },
            deep: true
        }
    },
    
    methods: {
        tryInit() {
            if (!this.$refs.pos_items) return
            if (!this.position_data || !this.columns?.length) return
            
            if (w2ui.positions) w2ui.positions.destroy()
            this.fixNumber()
            
            const self = this
            window.$ && window.$().w2grid({
                name: 'positions',
                show: { header: true, lineNumbers: true, toolbar: true, footer: true },
                columns: this.fix_caption(this.columns),
                columnGroups: this.fix_caption(this.columnGroups),
                records: this.fix_caption(this.records),
                
                onDblClick(event) {
                    
                    console.log('event_click',event);
                    
                    // «this» тут — экземпляр w2grid
                    const grid = this
                    if (grid.last.sel_col == null || isNaN(grid.last.sel_col)) return
                    const col   = w2ui.positions.columns[grid.last.sel_col]
                    const field = col?.field || ''
                    
                    // S-1 + app* => AddAll
                    if (event?.recid === 'S-1' && (field.startsWith('app') || col?.app?.startsWith?.('app'))) {
                        const appField = col.app || field
                        const appId = appField.replace(/^app/, '')
                        self.addAll(appId)
                        return
                    }
                    
                    if (!field) return
                    if (field.startsWith('app') || field.startsWith('price')) {
                        const rec = grid.get(event.recid)
                        const appId = (col.app || field).replace(/^app/, '')
                        
                        if (self.editSummMode) {
                            self.showEditApp(rec.id, appId)
                            return
                        }
                        
                        const newgrid = 'app' + appId
                        const title   = col.app_title
                        
                        if (!self.recAdded(newgrid, appId, rec, title)) {
                            const qWant = parseFloat(rec['quantity_app_' + appId] ?? 0) || 0
                            const give  = Math.min(qWant, parseFloat(rec.quantity_protocol ?? 0) || 0)
                            
                            // обновляем базовую запись для визуального остатка в основном гриде
                            rec['quantity_protocol' + appId] = give
                            rec['quantity_protocol'] = Math.max(0, (parseFloat(rec['quantity_protocol'] || 0) - give))
                            
                            // положить в holder
                            self.ensureWinnerGrid(appId)
                            const holder = self.protocol.position_grid_add.find(g => g.id === newgrid)
                            holder.records_push.push({ ...rec })
                            
                            try { w2ui.positions.refresh(); w2ui.positions.selectNone() } catch(e) {}
                            self.calcParams()
                        }
                    }
                }
            })
            
            window.$(this.$refs.pos_items).w2render('positions')
            w2ui.positions.show.header = true
            w2ui.positions.refresh()
            this.addButtonToolbar()
            
            this.calcOptimumMin((summ_opt) => {
                this.applyTotals(summ_opt, this.protocol.calculated_sum?.cur_sum || 0, 0)
            })
        },
        
        // --- ЛОГИКА ТОЛЬКО ЧЕРЕЗ position_grid_add --------------------------------
        
        ensureWinnerGrid(appId) {
            const gridName = 'app' + appId
            if (!this.protocol.position_grid_add.find(g => g.id === gridName)) {
                const title  = this.getAppTitle(appId)
                const header = `<i class="fas fa-minus-circle rem_sel" win_id="${gridName}" style="color:firebrick;cursor:pointer;"></i> ${title}`
                this.pushNewGrid(gridName, header)
            }
            return gridName
        },
        
        recAdded(gridName, contragentId, rec, title) {
            if (!rec) return false
            
            // уже в целевом holder'е
            const bag = this.protocol.position_grid_add.find(b => b.id === gridName)
            if (bag?.records_push?.some(r => String(r.id ?? r.recid) === String(rec.id))) {
                w2popup.open({
                    title: 'Запис вже додано',
                    body: `<div class="w2ui-centered">Контрагент ${title}<br>ця позиція вже у розподілі</div>`
                })
                return true
            }
            
            // уже распределена по записи (пер-app количества)
            const distributedTo = Object.entries(rec)
                .filter(([k, v]) => /^quantity_protocol\d+$/.test(k) && (parseFloat(v) || 0) > 0)
                .map(([k, v]) => ({ appId: k.replace('quantity_protocol', ''), qty: parseFloat(v) || 0 }))
            
            // уже лежит в других holders
            const alsoInHolders = []
            ;(this.protocol.position_grid_add || []).forEach(b => {
                if (b.id === gridName) return
                if (b.records_push?.some(r => String(r.id ?? r.recid) === String(rec.id))) {
                    alsoInHolders.push(b.id.replace(/^app/, ''))
                }
            })
            
            if (distributedTo.length > 0 || alsoInHolders.length > 0) {
                const listHtml = [
                    ...distributedTo.map(d => `${this.getAppTitle(d.appId)}: ${d.qty}`),
                    ...alsoInHolders.map(id => `${this.getAppTitle(id)}: у вкладці`)
                ].join('<br>')
                w2popup.open({ title: 'Відмова', body: `<div class="w2ui-centered">Позицію вже розподілено:<br>${listHtml}</div>` })
                return true
            }
            
            return false
        },
        
        async auto_distribute() {
            const main = w2ui.positions
            if (!main || !Array.isArray(main.records)) return
            
            IMC_CORE?.showloading?.()
            
            // чистим holders и визуальные остатки в основном гриде
            this.clearWinners()
            this.protocol.position_grid_add = []
            
            // 1) собрать позиции
            const positions = main.records.map(rec => {
                const posId = rec.id ?? rec.recid
                const quantityLeft = parseFloat(rec.quantity_protocol ?? rec.quantity ?? 0) || 0
                
                const app = Object.keys(rec)
                    .filter(k => k.startsWith('Price_'))
                    .map(k => {
                        const appId = k.slice(6)
                        const qApp  = parseFloat(rec['quantity_app_' + appId] ?? 0) || 0
                        const qUsed = parseFloat(rec['quantity_protocol' + appId] ?? 0) || 0
                        const free  = Math.max(0, qApp - qUsed)
                        const price = parseFloat(rec[k] ?? 0) || 0
                        return { app_id: appId, price, quantity: free }
                    })
                    .filter(x => x.quantity > 0)
                    .sort((a, b) => a.price - b.price)
                
                return { id: posId, source: rec, quantitytotal: quantityLeft, app }
            })
            
            // 2) greedy распределение -> buckets по holders
            const buckets = {} // { app{ID}: [records] }
            for (const pos of positions) {
                let toBuy = pos.quantitytotal
                if (toBuy <= 0 || pos.app.length === 0) continue
                
                for (const offer of pos.app) {
                    if (toBuy <= 0) break
                    const buy = Math.min(toBuy, offer.quantity)
                    if (buy <= 0) continue
                    
                    const gridName = this.ensureWinnerGrid(offer.app_id)
                    const copy = { ...pos.source }
                    copy['quantity_protocol' + offer.app_id] = buy
                    
                    const baseLeft = parseFloat(copy.quantity_protocol ?? copy.quantity ?? 0) || 0
                    copy.quantity_protocol = Math.max(0, baseLeft - buy)
                    
                    ;(buckets[gridName] ||= []).push(copy)
                    toBuy -= buy
                }
            }
            
            // 3) заливаем в holders
            Object.entries(buckets).forEach(([gridName, rows]) => {
                const holder = this.protocol.position_grid_add.find(g => g.id === gridName)
                if (holder) holder.records_push.push(...rows)
            })
            
            // 4) финальный пересчёт
            this.calcParams()
            
            IMC_CORE?.hideloading?.()
        },
        
        addAll(appId) {
            const main = w2ui.positions
            if (!main) return
            
            const appGridName = 'app' + appId
            
            // как раньше — оставить только один выбранный таб
            this.protocol.position_grid_add = []
            
            const title  = this.getAppTitle(appId)
            this.pushNewGrid(appGridName, `<i class="fas fa-minus-circle rem_sel" win_id="${appGridName}" style="color:firebrick;cursor:pointer;"></i> ${title}`)
            
            const toPush = []
            main.records.forEach(rec => {
                const qWant = parseFloat(rec['quantity_app_' + appId] ?? 0) || 0
                if (qWant <= 0) return
                
                const totalLeft = parseFloat(rec.quantity_protocol ?? rec.quantity ?? 0) || 0
                const give = Math.min(qWant, totalLeft)
                if (give <= 0) return
                
                const copy = { ...rec }
                copy['quantity_protocol' + appId] = give
                copy.quantity_protocol = +(totalLeft - give)
                
                toPush.push(copy)
            })
            
            if (toPush.length > 0) {
                this.protocol.position_grid_add.find(g => g.id === appGridName).records_push.push(...toPush)
                this.calcParams()
            }
        },
        
        // СЧЁТ ТОЛЬКО ПО HOLDERS
        calcParams(remGridId) {
            if (!w2ui.positions) return
            
            const selected = {} // posId -> { summ, quantity_protocol, 'quantity_protocol{appId}': qty }
            
            const collect = (appId, rows, skip) => {
                    const pKey = 'Price_' + appId
                    const qKey = 'quantity_protocol' + appId
                    const sKey = 'Sum_' + appId
                    
                    ;(rows || []).forEach(rec => {
                        const recId = rec.id ?? rec.recid
                        const q = parseFloat(rec[qKey] || 0) || 0
                        const price = parseFloat(rec[pKey] || 0) || 0
                        const sum = +(price * q).toFixed(2)
                        
                        // визуальные поля для winners
                        rec[sKey] = sum
                        rec['app' + appId] = (price === parseFloat(rec.min || 0))
                            ? `<div style="cursor:pointer;background-color:green;color:white;padding:2px;">${sum}</div>`
                            : `<div style="cursor:pointer;padding:2px;">${sum}</div>`
                        
                        if (skip) return
                        
                        if (!selected[recId]) selected[recId] = { summ: 0, quantity_protocol: 0 }
                        selected[recId].summ += sum
                        selected[recId].quantity_protocol += q
                        selected[recId][qKey] = (selected[recId][qKey] || 0) + q
                    })
                }
                
                // 1) собрать по всем holders
            ;(this.protocol.position_grid_add || []).forEach(b => {
                const appId = b.id.replace(/^app/, '')
                const skip = remGridId && b.id === remGridId
                collect(appId, b.records_push || [], skip)
            })
            
            // 2) применить к основному гриду (остатки и per-app)
            ;(w2ui.positions.records || []).forEach(item => {
                const baseQuantity = parseFloat(item.quantity || 0) || 0
                
                // reset вычисляемых
                Object.keys(item).forEach(k => {
                    if (k.startsWith('quantity_protocol') && k !== 'quantity_protocol') item[k] = 0
                    if (/^Sum_\d+$/.test(k)) item[k] = 0
                    if (/^app\d+$/.test(k)) item[k] = ''
                })
                item.quantity_protocol = baseQuantity
                
                const agg = selected[item.id]
                if (agg) {
                    const distributed = parseFloat(agg.quantity_protocol || 0) || 0
                    item.quantity_protocol = Math.max(0, baseQuantity - distributed)
                    Object.keys(agg).forEach(k => {
                        if (k.startsWith('quantity_protocol')) item[k] = agg[k]
                    })
                }
            })
            
            try { w2ui.positions.refresh() } catch(e) {}
            
            const summ_current = Object.values(selected).reduce((acc, v) => acc + (parseFloat(v.summ) || 0), 0)
            this.calcOptimumMin((summ_opt) => this.applyTotals(summ_opt, summ_current, 0))
        },
        
        // --- утилиты/вспомогательные как были -------------------------------------
        
        pushNewGrid($name, $title) {
            const neededFields = [
                'id',
                'title',
                'quantity_protocol' + $name.substring(3),
                'quantity_' + $name.substring(3),
                'app' + $name.substring(3),
                'price_val_' + $name.substring(3)
            ]
            const columns = this.position_data.columns.filter(col => neededFields.includes(col.field))
            const summaryKeys = ['S-1', 'S-2', 'S-3', 'S-4']
            const summary = this.position_data.records.filter(r => summaryKeys.includes(r.recid))
            
            this.protocol.position_grid_add.push({
                id: $name,
                title: $title,
                columns,
                summary,
                records_push: [],
            })
        },
        
        showEditApp(rec_id, contragentId) {
            EventBus.$emit('app:edit', { rec_id, contragentId })
        },
        
        clearWinners() {
            const grid = w2ui?.positions
            if (grid && Array.isArray(grid.records)) {
                grid.records.forEach(rec => {
                    const base = parseFloat(rec.quantity ?? 0) || 0
                    rec.quantity_protocol = base
                    Object.keys(rec).forEach(k => {
                        if (/^quantity_protocol\d+$/.test(k)) rec[k] = 0
                        if (/^Sum_\d+$/.test(k))              rec[k] = 0
                        if (/^app\d+$/.test(k))               rec[k] = ''
                    })
                })
                try { grid.refresh() } catch(e) {}
            }
            this.calcOptimumMin((summ_opt) => this.applyTotals(summ_opt, 0, 0))
        },
        
        calcOptimumMin(callback) {
            const grid = w2ui.positions
            if (!grid || !Array.isArray(grid.records)) { if (typeof callback === 'function') callback(0); return 0 }
            
            const positions = grid.records.map(rec => {
                const quantityTotal = parseFloat(rec.quantity ?? 0) || 0
                const app = Object.keys(rec)
                    .filter(k => k.startsWith('Price_'))
                    .map(k => {
                        const appId = k.slice(6)
                        const price = parseFloat(rec[k] ?? 0) || 0
                        const qApp  = parseFloat(rec['quantity_app_' + appId] ?? 0) || 0
                        return { app_id: appId, price, quantity: qApp }
                    })
                    .filter(x => x.quantity > 0)
                    .sort((a, b) => a.price - b.price)
                
                return { id: rec.id ?? rec.recid, quantitytotal: quantityTotal, app }
            })
            
            let totalSum = 0
            for (const pos of positions) {
                let remaining = pos.quantitytotal
                if (!remaining || pos.app.length === 0) continue
                for (const offer of pos.app) {
                    if (remaining <= 0) break
                    const buy = Math.min(remaining, offer.quantity)
                    if (buy > 0) { totalSum += buy * offer.price; remaining -= buy }
                }
            }
            
            if (typeof callback === 'function') callback(totalSum)
            return totalSum
        },
        
        applyTotals(summ_opt, summ_current, summ_ower) {
            this.protocol.calculated_sum = { opt_sum: summ_opt, cur_sum: summ_current, over_sum: summ_ower }
        },
        
        fix_caption(items = []) {
            return items.map(item => {
                if (Object.prototype.hasOwnProperty.call(item, 'caption')) item.text = item.caption
                return item
            })
        },
        
        addButtonToolbar() {
            const self = this
            const add = (id, text) =>
                w2ui.positions.toolbar.add({
                    type: 'check', id, text, icon: 'w2ui-icon-columns',
                    onClick: (event) => self.sh_col(event)
                })
            
            add('quantity_', '"Кількість"')
            add('quantity_protocol', '"Кількість Протокол"')
            add('price', '"Ціна(грн)"')
            add('price_val_', '"Ціна(валюта)"')
            add('app', '"Сума(грн)"')
            add('comment', '"Коментар"')
            
            ;['comment', 'quantity_protocol', 'price_val_'].forEach(id => {
                w2ui.positions.toolbar.set(id, { checked: true })
                this.sh_col({ object: { id } })
            })
            
            w2ui.positions.toolbar.refresh()
        },
        
        sh_col(event) {
            const id  = event.object.id
            const reg = new RegExp(id + '(\\d+)')
            w2ui.positions.columns.forEach((col) => {
                if (reg.test(col.field)) col.hidden = !col.hidden
            })
            w2ui.positions.refreshBody()
            w2ui.positions.resizeRecords()
        },
        
        fixNumber() {
            if (window.w2utils?.formatNumber) {
                const orig = w2utils.formatNumber
                w2utils.formatNumber = function (val, fraction, useGrouping) {
                    if (useGrouping !== true && useGrouping !== false) useGrouping = false
                    return orig.call(this, val, fraction, useGrouping)
                }
            }
        },
        
        getAppTitle(appId) {
            const appField = 'app' + appId
            const col = (w2ui.positions?.columns || []).find(c => c.field === appField) || {}
            return col.app_title || col.caption || col.text || ('Контрагент ' + appId)
        },
    },
    
    computed: {
        position_data() { return this.protocol?.positions || null },
        columns()       { return this.position_data?.columns || [] },
        columnGroups()  { return this.position_data?.columnGroups || [] },
        records()       { return this.position_data?.records || [] },
    },
}
</script>

<style scoped></style>
